import { getHash } from '../../utils/getHash';

interface SellLimitHashOptions {
    startDate: string;
    endDate: string;
}
export const getSellLimitHash = ({ startDate, endDate }: SellLimitHashOptions) => getHash({ startDate, endDate });
